import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormikContext } from "formik";
import { useEffect } from "react";
import { useInitialSettings } from "../../../../../../context/settings";
import useWallet from "../../../../../../hooks/useWallet";
import { useWalletProvidersReady } from "../../../../../../context/walletProviders";
const depositMethods = [
    {
        id: 'wallet',
        display_name: 'Wallet'
    },
    {
        id: 'deposit_address',
        display_name: 'Deposit address'
    }
];
const DepositMethodComponent = () => {
    const { values, setFieldValue, } = useFormikContext();
    const { depositMethod: defaultDepositMethod, hideDepositMethod } = useInitialSettings();
    const { from, depositMethod, fromExchange, fromAsset } = values;
    const { provider } = useWallet(from, 'withdrawal');
    const providersReady = useWalletProvidersReady();
    const name = 'depositMethod';
    const menuItems = from && GenerateDepositMethodMenuItems(from, depositMethods, provider);
    const defaultMethod = menuItems?.find(i => i.id === defaultDepositMethod);
    useEffect(() => {
        if (fromExchange) {
            setFieldValue(name, 'deposit_address', true);
            return;
        }
        if (!providersReady)
            return;
        // A currently-valid selection (e.g. the user's explicit pick in
        // SourceWalletPicker) always wins; the integrator default and the
        // first-item fallback only fill in a missing or invalid value. The
        // effect re-runs on every provider snapshot movement, so re-asserting
        // the default here would silently revert the user's choice.
        if (menuItems?.find(i => i.id === depositMethod))
            return;
        setFieldValue(name, defaultMethod ? defaultMethod.id : menuItems?.[0]?.id, true);
    }, [from, fromExchange, fromAsset, provider, providersReady]);
    const hasOptions = Number(menuItems?.length) > 1 && !fromExchange;
    if (!hasOptions || (defaultMethod && hideDepositMethod))
        return null;
    return (_jsx(_Fragment, {})
    // <div className="relative w-full mb-1">
    //     <Popover open={showModal} onOpenChange={setShowModal}>
    //         <PopoverTrigger className="font-semibold text-secondary-text text-xs flex items-center space-x-1 p-2">
    //             <span> Transfer via </span> <span>{selectedMethod?.toLowerCase()}</span> <motion.div
    //                 animate={showModal ? "open" : "closed"}
    //                 variants={variants}
    //             >
    //                 <ChevronDown className="w-4 h-4" />
    //             </motion.div>
    //         </PopoverTrigger>
    //         <PopoverContent className='ml-2 mt-1 space-y-1 text-sm p-2 max-w border-none rounded-xl bg-secondary-800 max-w-72 md:max-w-96' align="start">
    //             <DepositMethod
    //                 onselect={handleSelect}
    //                 value="wallet"
    //                 icon={<WalletIcon
    //                     strokeWidth={2} className="w-6 h-6" />}
    //                 description="Connect your wallet and transfer instantly"
    //                 title="Wallet"
    //                 selectedValue={depositMethod}
    //             />
    //             <DepositMethod
    //                 onselect={handleSelect}
    //                 value="deposit_address"
    //                 icon={<AlignLeft strokeWidth={2} className="w-6 h-6" />}
    //                 description="Manually transfer to a Deposit Address generated specifically for you"
    //                 title="Deposit address"
    //                 selectedValue={depositMethod}
    //             />
    //         </PopoverContent>
    //     </Popover>
    // </div>
    );
};
const DepositMethod = ({ icon, title, description, selectedValue, value, onselect }) => {
    const selected = selectedValue === value;
    return (_jsx("div", { className: `p-3 ${selected ? 'text-primary-text bg-secondary-600' : 'text-secondary-text'} flex rounded-lg cursor-pointer hover:bg-secondary-500`, onClick: () => onselect(value), children: _jsxs("div", { className: "grid grid-cols-9 gap-2 md:gap-0 w-full", children: [_jsx("div", { children: icon }), _jsxs("div", { className: " col-span-8   flex", children: [_jsxs("div", { className: "w-full", children: [_jsx("div", { className: `font-semibold text-base`, children: title }), _jsx("div", { className: "text-secondary-text text-xs", children: description })] }), selected &&
                            _jsx("div", { className: "flex items-center justify-center", children: _jsx("svg", { className: "w-6 h-6", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", d: "M5 13l4 4L19 7" }) }) })] })] }) }));
};
function GenerateDepositMethodMenuItems(network, depositMethods, walletProvider) {
    if (!walletProvider) {
        return depositMethods.filter(m => m.id === 'deposit_address');
    }
    return depositMethods.filter(m => network?.deposit_methods?.some(dm => dm === m.id));
}
export default DepositMethodComponent;
